<div mat-dialog-title>
  <app-dialog-close-cross></app-dialog-close-cross>
  <h2>{{ 'REFDATA.PARTNERS.EDIT.MODAL_ADD_MARKET' | translate }}</h2>
</div>

<div mat-dialog-content>
  <form>
    <app-market-selector (selectedMarketsChange)="add($event)"></app-market-selector>
  </form>
</div>

<div mat-dialog-actions>
  <button class="space-h-s btn-warn" mat-raised-button (click)="cancel()">{{ 'CANCEL' | translate }}</button>
  <button class="space-h-s btn-submit" mat-raised-button (click)="submitSelection()">{{ 'REFDATA.PARTNERS.EDIT.ADD' | translate }}</button>
</div>
